import type { EnumsSimStatus } from 'types/__generated__/SimInventoryApi';
import type {
  DataUsageCondition,
  DataUsageUnit,
  DateFilter,
  HologramSimIdsMap,
  SimKey,
  TextFilter,
} from 'types/common';

export type SortDirection = 'asc' | 'desc' | undefined;

export interface Sort {
  property: SimKey;
  ordering: SortDirection;
  nullsFirst?: boolean;
}

export interface ActivationDate extends DateFilter {}

export interface TargetActivationDate extends DateFilter {}

export interface LastActive extends DateFilter {}

export interface DataUsage {
  dataUsageCondition?: DataUsageCondition;
  dataUsageUnit?: DataUsageUnit;
  dataUsageValue?: Number;
}

export type SimStatusFilter = Array<EnumsSimStatus>;
export type TagFilter = Array<TagId>;
export type PlanFilter = Array<PlanId>;

export interface StoredFilters {
  organizationId?: OrgId;
  deviceName?: string;
  iccid?: TextFilter;
  imei?: TextFilter;
  activationDate?: ActivationDate;
  targetActivationDate?: TargetActivationDate;
  lastActive?: LastActive;
  dataUsage?: DataUsage;
  simStatuses?: SimStatusFilter;
  tags?: TagFilter;
  noTags?: boolean;
  plans?: PlanFilter;
}

export const ValidFilterKeys = new Set<keyof StoredFilters>([
  'organizationId',
  'deviceName',
  'iccid',
  'imei',
  'activationDate',
  'targetActivationDate',
  'lastActive',
  'dataUsage',
  'simStatuses',
  'tags',
  'noTags',
  'plans',
]);

export type AllCheckboxState = 'checked' | 'indeterminate' | undefined;

export interface Selected {
  all?: AllCheckboxState;
  sims?: HologramSimIdsMap;
}

export interface SimInventorySegmentSelectionState {
  selected: Selected;
}
